import BHBenefitRoutes from '@/lib/constants/bh_benefit_route_names';
import BhBenefits from '../../apps/bhBenefits/BhBenefits.vue';
import BhBenefitsLanding from '../../apps/bhBenefits/landing/BhBenefitsLanding.vue';
import UpgradeFlow from '../../apps/bhBenefits/upgrade/UpgradeFlow.vue';
import VerifyCorporateUpgrade from '../../apps/bhBenefits/upgrade/VerifyCorporateUpgrade.vue';
import BhBenefitsSignUp from '../../apps/bhBenefits/signUp/BhBenefitsSignUp.vue';
import BhBenefitsYearsAhead from '../../apps/bhBenefits/signUp/BhBenefitsYearsAhead.vue';
import corporateVerificationGuard from '../guards/corporateVerificationGuard';

const bhBenefitsRoutes = [
  {
    path: '/bh-benefits',
    component: BhBenefits,
    meta: { hideMainHeader: true, skipAuth: true },
    children: [
      {
        name: BHBenefitRoutes.HOME,
        path: '',
        component: BhBenefitsLanding,
      },
      {
        name: BHBenefitRoutes.UPGRADE,
        path: 'upgrade',
        component: UpgradeFlow,
        meta: { skipAuth: false },
      },
      {
        name: BHBenefitRoutes.VERIFY,
        path: 'verify/:token',
        component: VerifyCorporateUpgrade,
        beforeEnter: corporateVerificationGuard,
      },
      {
        path: ':slug',
        name: BHBenefitRoutes.SIGNUP,
        component: BhBenefitsSignUp,
      },
      {
        name: BHBenefitRoutes.YA_SIGNUP,
        path: ':slug/signup',
        component: BhBenefitsYearsAhead,
        beforeEnter(to, from, next) {
          if (to.query.site === 'years_ahead') {
            next();
          } else {
            next({ name: BHBenefitRoutes.SIGNUP, params: { slug: to.params.slug }, query: to.query });
          }
        },
      },
    ],
  },
];

export default bhBenefitsRoutes;
